import { SERVICE_OGP_IMAGE, SITE_URL } from '../../constants'
import { buildServiceSchema } from '../../builders/service'
import { PageMeta } from '../../types'

const description =
  '「使いにくい」を根拠のある設計で解消します。OOUI・ブランドアーキタイプ・エキスパートレビューなど独自のフレームワークを駆使し、SaaS・業務システム・モバイルアプリのUX/UIを改善。デザインシステム構築や内製化支援にも対応します。'

export const uxuiImprovementPageMeta: PageMeta = {
  title: 'UX/UI改善・UIデザイン設計支援 | OOUI×エキスパートレビュー | i3DESIGN',
  description,
  keyword: 'UIUX デザイン OOUI アプリ エキスパートレビュー ブランドアーキタイプ',
  image: SERVICE_OGP_IMAGE,
  url: `${SITE_URL}/services/uxui-improvement/`,
}

export const uxuiImprovementSchema = buildServiceSchema({
  slug: 'uxui-improvement',
  name: 'UX/UI改善支援',
  description: uxuiImprovementPageMeta.description,
  serviceType: 'UX/UI改善支援',
  category: 'デジタルプロダクトデザイン',
  offerCatalogName: 'UX/UI改善支援サービス',
  breadcrumbName: 'UX/UI改善支援',
  offers: [
    {
      name: 'オブジェクトモデリング(OOUI)',
      description:
        'OOUIは、現実世界と同様に「何を（オブジェクト）」を選んでから「どうするか（アクション）」を決める設計手法であり、直感的な操作感を実現します。この思想をプロセスに組み込むことで、ユーザーの思考モデルとプロダクトの構造が一致し、スムーズで使い勝手の良い体験を提供できます。',
    },
    {
      name: 'ユースケース・シナリオ設計',
      description:
        'UI設計では機能間のつながりや最適な配置を精査することが不可欠であり、単に機能を並べるだけでは操作性や構造に矛盾が生じてしまいます。こうした整理を徹底することで、その後のモデリングや設計工程において、システムとユーザー双方の視点を持った一貫性のある情報設計が可能になります。',
    },
    {
      name: 'エキスパートレビュー',
      description:
        '経験豊富なデザイナーが、プロダクトを「構造・骨格・表層」の3視点と「10のヒューリスティクス」に基づき、経験と理論の両面から多角的に分析します。この評価から導き出した改善方針とともに、具体的な修正案を提示することでプロダクトの課題解決をトータルにサポートします。',
    },
    {
      name: 'ブランドアーキタイプ分析',
      description:
        'ブランドアーキタイプとは、ユングの心理パターンを応用してブランドの人格を定義する手法であり、市場競争力やユーザーとの結びつきを強める効果があります。これをプロダクトの設計に用いることで、理想的な人格を論理的に導き出し、チーム内やユーザーとの認識のズレを未然に防ぐことが可能になります。',
    },
  ],
})
